import React from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import geoData from 'world-atlas/countries-110m.json';

// Reusable stylised world map with clickable region markers
const WorldMap = ({ regions = [], activeId, onSelect }) => {
  return (
    <div className="w-full">
      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{ scale: 165 }}
        width={900}
        height={420}
        style={{ width: '100%', height: 'auto' }}
      >
        <Geographies geography={geoData}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#DFD6BF"
                stroke="#F7F1E3"
                strokeWidth={0.5}
                style={{
                  default: { outline: 'none' },
                  hover: { fill: '#CFC3A3', outline: 'none' },
                  pressed: { outline: 'none' },
                }}
              />
            ))
          }
        </Geographies>
        {regions.map((r) => {
          const isActive = activeId === r.id;
          const isMarket = r.type === 'market';
          const base = isMarket ? '#B08D3C' : '#14432A';
          return (
            <Marker key={r.id} coordinates={r.coordinates} onClick={() => onSelect && onSelect(r.id)} style={{ default: { cursor: 'pointer' } }}>
              {isActive && <circle r={13} fill={base} opacity={0.25} />}
              <circle r={isActive ? 7 : 5} fill={isActive ? '#B08D3C' : base} stroke="#F7F1E3" strokeWidth={1.5} />
            </Marker>
          );
        })}
      </ComposableMap>
    </div>
  );
};

export default WorldMap;
